import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileValidationService {
  private readonly ocrReadyFormats: string[] = [
    'pdf',
    'tif',
    'tiff'
  ];

  private readonly supportedImageFormats: string[] = [
    'jpg',
    'jpeg',
    'gif',
    'bmp',
    'png'
  ];

  private readonly supportedMicrosoftFormats: string[] = [
    'doc',
    'docx',
    'xlsx',
    'xls',
    'pptx',
    'ppt',
    'rtf',
    'csv',
    'txt'
  ];

  private readonly supportedScriptFormats: string[] = [
    'ps'
  ];

  constructor() { }

  private getAllSupportedFormats(): string[] {
    return [
      ...this.ocrReadyFormats,
      ...this.supportedImageFormats,
      ...this.supportedMicrosoftFormats,
      ...this.supportedScriptFormats
    ];
  }

  public isFileTypeSupported(file: File): { isValid: boolean; errorMessage?: string } {
    if (!file || !file.name) {
      return {
        isValid: false,
        errorMessage: 'Invalid file object'
      };
    }

    const extension = file.name.split('.').pop()?.toLowerCase();

    if (!extension) {
      return {
        isValid: false,
        errorMessage: 'File has no extension'
      };
    }

    if (!this.getAllSupportedFormats().includes(extension)) {
      return {
        isValid: false,
        errorMessage: 'Unsupported file type'
      };
    }

    return { isValid: true };
  }
}